import { useState } from 'react';
import { pick } from 'lodash/object';

export const CollectACHDetailsFlow = ({ recipientLogin, children }) => {
  const [isFetching, setIsFetching] = useState(false);

  const onSubmit = async (formData) => {
    try {
      setIsFetching(true);

      // sample form data based on the form fields in the CollectACHDetailsView
      // const formData = {
      //   ach: {
      //     name_on_account: '',
      //     account_number: '',
      //     routing_number: '',
      //     account_type: '',
      //   },
      // };

      const { ach } = formData;

      // map data to format expected by /recipientLogins
      const dataForRecipientLogin = {
        account_number: ach.account_number,
        bank_code: ach.routing_number,
        account_type: ach.account_type,
        name: ach.name_on_account,
      };

      // don't log bank account info
      const dataForLogs = pick(dataForRecipientLogin, [
        'name',
      ]);

      await recipientLogin({
        dataForRecipientLogin,
        skipDefaultPostEffects: false,
        customLogData: dataForLogs,
      });

      // example response from /recipientLogins
      // const {
      //   accessToken,
      //   additionalData: {
      //     networkResponse: {
      //       payment_instrument: {
      //         name,
      //         bank_code,
      //         masked_account_number: { account_number },
      //         account_type,
      //         created_at,
      //         updated_at,
      //       },
      //     },
      //   },
      // } = recipientLoginResponse;
    } catch (error) {
      setIsFetching(false);
    }
  };

  return children({
    onSubmit,
    isFetching,
  });
};

export default CollectACHDetailsFlow;
